import { render, staticRenderFns } from "./recommend_item_cmmdty.vue?vue&type=template&id=c9a685de&scoped=true&"
import script from "./recommend_item_cmmdty.vue?vue&type=script&lang=ts&"
export * from "./recommend_item_cmmdty.vue?vue&type=script&lang=ts&"
import style0 from "./recommend_item_cmmdty.vue?vue&type=style&index=0&id=c9a685de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9a685de",
  null
  
)

export default component.exports